import { useCallback } from 'react';

import { useSieMethods } from '@/hooks/use-sie';

import { sendEventAndWait } from './data-layer';
import { resolveSignUpCompleteEvent } from './events';

/** SNS で新しいユーザーが作られたことを送る。RP へリダイレクトする直前に await すること。 */
const useSignUpCompleteTracking = (connectorId: string) => {
  const { socialConnectors } = useSieMethods();

  return useCallback(async () => {
    const target = socialConnectors.find(({ id }) => id === connectorId)?.target;
    await sendEventAndWait(resolveSignUpCompleteEvent(target));
  }, [connectorId, socialConnectors]);
};

export default useSignUpCompleteTracking;
